import { render, staticRenderFns } from "./UpsellCollapse.vue?vue&type=template&id=079a96f2"
import script from "./UpsellCollapse.vue?vue&type=script&lang=js"
export * from "./UpsellCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports